<div class="booking-period-details">
  @if (isBookingRequest()) {
    <mat-chip class="abook-chip-2026 booking-period-request-chip">Forespørgsel</mat-chip>
  }
  <ng-content></ng-content>
</div>
